import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
import elementEnLocale from 'element-ui/lib/locale/lang/en'
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'

import enLocale from './en'
import zhLocale from './zh'


Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }

}
export function getLanguage() {
  const chooseLanguage = Cookies.get('language')
  if (chooseLanguage){
    if(navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
      const language = (navigator.language || navigator.browserLanguage).toLowerCase()
      const locales = Object.keys(messages)
      for (const locale of locales) {
        if (language.indexOf(locale) > -1) {
          return locale
        }
      }
    }
  } return chooseLanguage
  
  // return 'en'
}



const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
  locale: getLanguage(),
  // set locale messages
  messages
})

export function setLanguage(lang){
  i18n.locale = lang
}

export default i18n
